import Big from 'big.js';
import { replaceDecimalSeparator } from 'helpers/strings';

export function parseFloatValue(value) {
  const parsed = parseFloat(replaceDecimalSeparator(value));
  if (isNaN(parsed)) return 0;
  return parsed;
}

export function getBalance(balances, asset) {
  return balances.find(balance => balance.asset === asset)?.availableBalance ?? 0;
}

export function getEstimation(quantity = 0, fee = 0, orders = []) {
  const items = [...orders];
  const feePerc = Big(fee).div(100);
  let remainingQuantity = Big(quantity);
  let estimationPrice = Big(0);

  while (remainingQuantity.gt(0)) {
    const item = items.shift();
    if (!item) {
      break;
    }
    const itemQuantity = Big(item.quantity);
    const itemPrice = Big(item.price);
    // use available order quantity or fallback to remaining
    const effectiveQuantity =
      itemQuantity.gt(0) && itemQuantity.lt(remainingQuantity) ? itemQuantity : remainingQuantity;

    const chunkPrice = itemPrice.times(effectiveQuantity);
    estimationPrice = estimationPrice.plus(chunkPrice);
    remainingQuantity = remainingQuantity.minus(effectiveQuantity);
  }

  const estimationFee = estimationPrice.times(feePerc);

  return {
    fee: parseFloatValue(estimationPrice.times(feePerc).toString()).toFixed(2),
    price: parseFloatValue(estimationPrice.toString()).toFixed(2),
    total: parseFloatValue(estimationFee.plus(estimationPrice).toString()).toFixed(2)
  };
}
